export const DUTCH_TRANSLATIONS = {
  text: {
    web_title: 'SMARTZ™-DASHBOARD',
    authentication: 'Authenticatie',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    sign_in: 'Aanmelden',
    username_required: 'Gebruikersnaam is vereist',
    password_required: 'Wachtwoord is vereist',
    invalid_credential: 'Onjuiste gebruikersnaam of onjuist wachtwoord',
    forgot_password: 'Wachtwoord vergeten',
    change: 'Wijzigen',
    well_being: 'Welzijn',
    warnings: 'Waarschuwingen',
    no_patients_to_change: 'Geen patiënten om te verversen',
    no_patients: 'Geen patiënten',
    logout: 'Uitloggen',
    lost_connection: 'Verbinding verbroken met Smartz™ cloud',
    check_connection: 'Controleer uw internetverbinding',
    trying_to_reconnect: 'Proberen opnieuw te verbinden',
    pad_time: 'Tijd in luier',
    red_time: 'Tijd in het rood',
    position: 'Houding',
    time: 'Tijd',
    time_in_position: 'Tijd in houding',
    sitting: 'Zittend',
    standing: 'Staand',
    left: 'Links',
    right: 'Rechts',
    lying: 'Liggend',
    unknown: 'Onbekend',
    wet_surface: 'Nat oppervlak',
    out_of_range: 'Buiten bereik',
    low_battery: 'Batterij bijna leeg',
    disconnected: 'Verbinding verbroken',
    unexpected_problem: 'Onverwacht probleem',
    ok: 'OK',
    change_soon: 'Binnenkort vervangen',
    change_pad: 'Luier verschonen',
    languages: 'Talen',
    dashboard: 'DASHBOARD',
    pad_fill_profile: '{pad}vullingprofiel',
    goal: 'DOELEN',
    report: 'RAPPORT',
    manage: 'BEHEREN',
    individual: 'Individueel',
    group: 'Groep',
    action_required: 'ACTIE VEREIST',
    monitor: 'MONITOR',
    pod_unclipped: 'pod los geklikt',
    check_patient: '{patient} controleren',
    check_pad: 'luier controleren',
    check_time_in_pad: 'tijd in luier controleren',
    check_position: 'houding controleren',
    check_temperture: 'temperatuur controleren',
    check_pad_fill_profile: '{pad}VULLINGPROFIEL CONTROLEREN',
    instructions: 'instructies',
    time_in_pos: 'tijd in houding',
    pad_capacity: 'luiercapaciteit',
    time_in_pad: 'tijd in luier',
    ambient: 'omgeving',
    time_at_temp: 'tijd bij temp',
    pad_wet: 'LUIER NAT',
    pad_dry: 'LUIER DROOG',
    daily_pad_fill: 'Dagelijkse luiervulling',
    seven_day_trend: 'Zevendaagse trend',
    daytime: 'Overdag',
    nighttime: `'s Nachts`,
    volume_in_pad: 'Volume in luier',
    pad_fill_summary: 'SAMENVATTING PADVULLING',
    daily_average: 'Daggemiddelde',
    today: 'Vandaag',
    capacity: 'Capaciteit',
    pads_used: 'gebruikte luiers',
    per_day: 'per dag',
    average: 'gemiddeld',
    leakage_detected: 'Lekkage gedetecteerd',
    times: 'keer',
    pad_cycles: 'Luiercycli',
    time_in_a_pos: 'Tijd in een houding',
    max_time_in_a_pos: 'Maximale tijd in houding',
    re_positioning: 'Herpositionering',
    time_day: 'tijd/dag',
    temperature: 'Temperatuur',
    typical_temp: 'Typische temperatuur',
    temp_range: 'Temperatuurbereik',
    charts: 'GRAFIEKEN',
    pad_fill_profile_for_7_days: 'Luiervullingprofiel - Zevendaagse trend',
    daily_total: 'Dagelijks totaal',
    accuracy: 'nauwkeurigheid',
    last_24_hours: '24 uur vanaf geselecteerde datum',
    volume_voided_in_pad: 'volume geloosd in luier',
    body: 'Lichaam',
    wetness_usage: 'nattigheid/gebruik',
    environment_body: 'omgevingstemperatuur',
    activity: 'Activiteit',
    lift_style: 'liftstijl',
    skin_care: 'Huidverzorging',
    skin_care_management: 'huidverzorgingsbeheer',
    workflow: 'Workflow',
    workflow_efficiency: 'efficiëntie van workflow',
    set_maximum_voiding_volume_into_pad:
      'Stel het maximale urinelozingsvolume in de luier in',
    less_void: 'MINDER URINELOZING',
    more_void: 'MEER URINELOZING',
    day: 'DAG',
    night: 'NACHT',
    day_time: 'Overdag',
    night_time: `'s Nachts`,
    average_period: 'Gemiddelde periode',
    default: 'STANDAARD',
    desire_position: 'Tijd in houding',
    time_in_a_position: 'Tijd in een houding',
    desire_temperature: 'Pod-omgevingstemperatuur',
    coloer: 'KOUDER',
    hotter: 'WARMER',
    desire_skin_care: 'Huidverzorging',
    off: 'UIT',
    standard_care: 'STANDAARDVERZORGING',
    extra_care: 'EXTRA VERZORGING',
    more_time_in_wet_pad: 'MEER TIJD IN NATTE LUIER',
    more_time_in_a_pos: 'MEER TIJD IN EEN HOUDING',
    less_time_in_wet_pad: 'MINDER TIJD IN NATTE LUIER',
    less_time_in_a_pos: 'MINDER TIJD IN EEN HOUDING',
    override: 'Dit doel heeft voorrang op luier- en lichaamsdoelen',
    check_pod: 'pod controleren',
    check_pod_and_reclip: 'pod controleren en opnieuw met clip bevestigen',
    lost_connect: 'Verbinding verbroken',
    voids_into_pad_hours: 'Urinelozingen in luier in 96 uur',
    chart_date: 'Grafiek Datum',
    fullscreen: 'Volledig scherm',
    normalscreen: 'Normaal scherm',
    void_chart: 'Urinelozingsgrafiek',
    voids_into_pad: 'urinelozingen in luier',
    pad_fill_trend: 'luiervullingstrend',
    legend: 'LEGENDA',
    new_pad: 'nieuwe luier',
    void_in_pad: 'urinelozing in luier',
    share: 'Delen',
    print: 'Afdrukken',
    position_profile: 'Houdingenprofiel',
    body_position: 'Lichaamshouding',
    body_positions_over_96_hours: 'Lichaamshoudingen gedurende 96 uur',
    lying_on_back: 'Liggend - op de rug',
    lying_on_front: 'Liggend - op de buik',
    lying_left_side: 'Liggend - op de linkerzij',
    lying_right_side: 'Liggend - op de rechterzij',
    standing_walking: 'Staand/lopend',
    stats: 'statistieken',
    pad_used: 'luier_gebruikt',
    max: 'maximaal',
    surrounding_temperature: 'OMGEVINGSTEMPERATUUR',
    temp: 'temperatuur',
    avg: 'gem.',
    name: 'Naam',
    provider: 'Leverancier',
    purpose: 'Doel',
    expiry: 'Verval',
    type: 'Type',
    frequently_asked_questions: 'Veelgestelde vragen',
    information_for_use: 'Gebruiksinformatie',
    data_privacy: 'Privacy van gegevens',
    eula: 'EULA',
    about: 'Over',
    settings: 'Instellingen',
    save: 'Opslaan',
    version: 'versie',
    support: 'ondersteuning',
    close: 'Sluiten',
    copyright:
      'Copyright (C) 2022 Smartz Operations Limited. Alle rechten voorbehouden',
    smartz_devices: 'Smartz™-apparaten',
    monitor_smartz_device_operation:
      'de werking van het Smartz™-apparaat monitoren',
    last_seen: 'Laatst bekeken',
    battery: 'Batterij',
    ago: 'geleden',
    date_rate: 'Datum tarief',
    online: 'Online',
    singnal: 'Signaal',
    temperature_goal: 'TEMPERATUURDOEL',
    data_privacy_desc: 'toestemming en persoonlijke gegevens beheren',
    organisation: 'ORGANISATIE',
    organisation_desc: 'groepsinstellingen beheren',
    my_account: 'Mijn account',
    my_account_desc: 'accountinstellingen beheren',
    consent: 'Toestemming',
    marketing_comm: 'Marketing, communicatie en promoties',
    consent_desc:
      'Luierfabrikanten en -distributeurs kunnen persoonlijke gegevens gebruiken voor marketing en promoties. Er kunnen van tijd tot tijd e-mails worden verzonden naar het eventuele gebruikersaccount dat aan deze patiënt is gekoppeld. In dit geval kan het e-mailadres van de gebruiker worden gedeeld met derden.',
    data_management: 'Gegevensbeheer',
    Permanently_delete_account: 'Dit gebruikersaccount definitief verwijderen',
    permanently_delete_client: 'Deze klant definitief verwijderen',
    data_management_desc:
      'Het account is niet langer beschikbaar en alle gegevens in het account worden permanent verwijderd.',
    how_can_i_export:
      'Hoe kan ik mijn accountgegevens exporteren en er een back-up van maken?',
    save_preference: 'VOORKEUR OPSLAAN',
    delete_account_data: 'ACCOUNT EN GEGEVENS VERWIJDEREN',
    date_time_settings: 'Datum- en tijdinstellingen',
    morning_time: 'Ochtend',
    night_time_label: 'Nacht',
    time_format: 'Tijdweergave',
    date_format: 'Datumnotatie',
    goal_text: 'doel',
    day_goal: 'dagdoel',
    night_goal: 'nachtdoel',
    check_battery: 'BATTERIJ CONTROLEREN',
    reminders: 'herinneringen',
    update_data_privacy_consent: 'Update van gegevensprivacytoestemming',
    update: 'Bijwerken',
    user: 'Gebruiker',
    last_updated: 'Voor het laatst bijgewerkt',
    action: 'Handeling',
    delete_confirm: 'Weet u zeker dat u dit wilt verwijderen?',
    cancel: 'Annuleren',
    lost_internet_connection: 'VERLOREN INTERNETVERBINDING',
    check_setting: 'Controleer uw internetinstellingen en -verbindingen',
    authentication_required: 'Authenticatie vereist',
    account_details_have_changed: 'Accountgegevens zijn gewijzigd',
    date: 'Datum',
    no_pod_assigned: 'geen pod toegewezen',
    monitoring_is_not:
      'Monitoring is niet beschikbaar omdat er geen Smartz™-pod is toegewezen aan ',
    assign_a_pod: 'Een pod toewijzen aan',
    on_the_smartz_monitor_app:
      'op de Smartz™ Monitoring-app om monitoring te activeren.',
    see: 'Bekijken',
    delete: 'verwijderen',
    keep_in_mind_delete_data:
      'Houd er rekening mee dat het verwijderen van een gebruikersaccount en persoonlijke gegevens definitief is.',
    you_able_to_delete_data: 'U staat op het punt om te verwijderen',
    account_and_data: 'account en gegevens',
    this: 'dit',
    average_time_in_pad: 'Gemiddelde tijd in {pad}',
    average_time_in_position: 'Gemiddelde tijd in houding',
    repositioning_24h: 'Herpositionering 24 uur',
    last_7_day_period: 'Laatste periode van 7 dagen',
    admin: 'ADMIN',
    administraive_settings: 'administratieve instellingen',
    group_data_rentenion: 'Bewaren van groepsgegevens',
    maximum_inactivity_data_retention_period:
      'Maximale bewaarperiode voor inactiviteitsgegevens',
    group_data_rentenion_desc:
      'Persoonlijke gegevens van alle gebruikers en {patients} binnen deze groep worden verwijderd als de inactiviteitsperiode is bereikt.',
    data_rentenion_detail:
      'De voorwaarde voor inactiviteit is als volgt:<br>- Pod is niet toegewezen aan de {patient} voor een bepaalde periode<br>- Pod is toegewezen aan de {patient}, maar verzendt geen gegevens naar Smartz™-apps voor een bepaalde periode<br>- Gebruiker heeft zich niet aangemeld voor een bepaalde periode',
    months: 'maanden',
    user_roles: 'Gebruikersrollen',
    users: 'Gebruikers',
    role: 'Rol',
    filter_by_group_or_users: 'filteren op groep of gebruikers',
    urine_conversion_feature: 'Functie voor urineconversie',
    use_urine_transform: 'Urinetransformatie gebruiken',
    system_data_rentenion: 'Bewaren van systeemgegevens',
    system_data_rentenion_desc:
      'Persoonlijke gegevens van alle gebruikers en {patients} binnen dit systeem worden verwijderd als de inactiviteitsperiode is bereikt.',
    reset_password: 'Wachtwoord resetten',
    new_password: 'Nieuw wachtwoord',
    confirm_password: 'Wachtwoord bevestigen',
    password_inconsistent: 'Het wachtwoord is niet consistent',
    edit: 'bewerken',
    edit_roles: 'Rollen bewerken',
    available_roles: 'Beschikbare rollen',
    assigned_roles: 'Toegewezen rollen',
    role_list: 'Rollenlijst',
    role_name: 'Naam van rol',
    role_permissions: 'Rechten van rol',
    level_1_module: 'Niveau 1 module',
    level_2_module: 'Niveau 2 module',
    permissions: 'Rechten',
    add_role: 'ROL TOEVOEGEN',
    roles: 'rollen',
    role_settings: 'rolinstellingen',
    edit_role: 'Rol bewerken',
    account_take_effect:
      'De update wordt van kracht nadat u opnieuw bent ingelogd.',
    algorithms: 'Algoritmes',
    delete_role_confirm: 'Het verwijderen van de rol is permanent.',
    //translate permissions list
    'Dashboard Module': 'Dashboardmodule',
    'Charts Module': 'Grafiekenmodule',
    'Goals Module': 'Doelenmodule',
    'Manage Module': 'Beheermodule',
    Group: 'Groep',
    Individual: 'Individueel',
    'Voiding Chart': 'Urinelozingsgrafiek',
    'Pad Fill Profile Chart':
      'Luiervullingprofielgrafiek (pad fill profile chart)',
    'Body Position Chart': 'Lichaamshoudinggrafiek',
    'Smartz Devices Chart': 'Grafiek van Smartz™-apparaten',
    'Pad Fill Profile': 'Luiervullingprofiel',
    'Skin Care': 'Huidverzorging',
    Position: 'Houding',
    Temperature: 'Temperatuur',
    Admin: 'Admin',
    'My Account': 'Mijn account',
    Role: 'Rol',
    Organisation: 'Organisatie',
    'Data Privacy': 'Privacy van gegevens',
    View: 'Bekijken',
    Share: 'Delen',
    Print: 'Afdrukken',
    Save: 'Opslaan',
    'Reset Password': 'Wachtwoord resetten',
    Delete: 'Verwijderen',
    Add: 'Toevoegen',
    Edit: 'Bewerken',
    Fall: 'Val',
    //end translate permissions list
    check_fall: 'VAL BEKIJKEN',
    position_goal_not_allow_off:
      'Houdingendoel kan niet worden UITGESCHAKELD (OFF) terwijl Valdoel is ingeschakeld om de veiligheid te verbeteren.',
    falls: 'Vallen',
    falls_detection_and_notification: 'valdetectie en -melding',
    falls_detection: 'Valdetectie',
    detect_falls: 'Val detecteren',
    on: 'AAN (ON)',
    position_goal: 'Houdingendoel',
    has_been_turn_on:
      'is INGESCHAKELD (ON) om valdetectie aan te vullen en de veiligheid te verbeteren.',
    last_fall: 'Laatste val',
    last_week: 'vorige week',
    three_months: '3 maanden',
    time_to_change: 'Tijd om te verschonen',
    sent_successfully: 'Verzenden gelukt',
    sent_failed: 'Verzenden mislukt',
    send_email: 'E-mail verzenden',
    send: 'Verzenden',
    add_email: 'E-mail toevoegen',
    saved_successfully: 'Opslaan gelukt',
    saved_failed: 'Opslaan mislukt',
    deleted_successfully: 'Succesvol verwijderd',
    deleted_failed: 'Verwijderen mislukt',
    email: 'E-mail',
    please_enter_email_address: 'Vul e-mailadres in',
    please_enter_the_correct_email_address: 'Voer het correcte e-mailadres in',
    time_in_a_pad_goal: 'TIJD IN EEN LUIER: DOEL',
    time_goal: 'TIJDSDOEL',
    body_temperature: 'Lichaamstemperatuur',
    upper_goal_limit: 'bovenste doellimiet',
    lower_goal_limit: 'onderste doellimiet',
    time_of_fall: 'tijd van de val',
    heart_rate: 'Hartslag',
    max_heart_rate: 'Maximale hartslag',
    min_heart_rate: 'Minimale hartslag',
    average_heart_rate: 'Gemiddelde hartslag',
    oximetry: 'Oximetrie',
    blood_o2_saturation: 'bloedzuurstofverzadiging',
    min_oximetry: 'Min. oximetrie',
    max_oximetry: 'Max. oximetrie',
    average_oximetry: 'Gemiddelde oximetrie',
    respiration: 'Ademhaling',
    breathing_pattern: 'ademhalingspatroon',
    breath: 'adem',
    respiration_vs_oximetry: 'Ademhaling versus oximetrie',
    min_respiration: 'Min. ademhaling',
    max_respiration: 'Max. ademhaling',
    average_respiration: 'Gemiddelde ademhaling',
    balance: 'Balans',
    falls_and_balance: 'vallen en evenwicht',
    loss_of_balance_events: 'Gebeurtenissen van evenwichtsverlies',
    sudden_changes_in_body_orientation:
      'Plotselinge veranderingen in lichaamsoriëntatie',
    goal_limit: 'doellimiet',
    last_event_exceeding_goal: 'Laatste gebeurtenis die het doel overschrijdt',
    balance_loss_events: 'Gebeurtenissen van evenwichtsverlies',
    per_7_days: 'per 7 dagen',
    body_lean_over_7_days: 'Leunen van lichaam gedurende 7 dagen',
    chart_shows_tendency:
      'De grafiek toont de neiging van het lichaam om tijdens het bewegen in een bepaalde richting te leunen',
    lean_forward: 'Voorwaarts leunen',
    backwards: 'achterwaarts',
    forward: 'voorwaarts',
    vitals: 'VITALE FUNCTIES',
    vitals_signs: 'VITALE TEKENS',
    spo2: 'SPO2',
    pulse: 'Puls',
    abdominal_movement: 'Buikbeweging',
    min: 'min',
    attach_the_pod:
      'Bevestig de pod alleen als de {pad} al bij de {patient} is aangebracht. Als u deze instructie niet opvolgt, kan een val ten onrechte worden gedetecteerd als gevolg van de beweging en hantering van de luier voordat deze bij de {patient} wordt aangebracht.',
    body_positions_analysis: 'Analyse van lichaamshoudingen',
    repositioning: 'Herpositionering',
    stayed_in_one_position: 'bleef in één houding',
    change_in_position: 'van houding veranderen',
    no_pod_data: 'geen pod-gegevens',
    possible_intervention: 'Mogelijke interventie',
    body_position_goal: 'DOEL VAN LICHAAMSHOUDING',
    tap_to_setup_body_position_goals:
      'tikken om lichaamshoudingsdoelen in te stellen',
    time_blocks_greater_than: 'tijdblokken groter dan',
    will_be_highlighted: 'zal worden gemarkeerd',
    chart_filters: 'GRAFIEKFILTERS',
    tap_to_show: 'tikken om weer te geven',
    tap_to_hide: 'tikken om te verbergen',
    notifications: 'Meldingen',
    time_to_reposition: 'Tijd-tot-herpositionering',
    hour: 'uur',
    hours: 'uur',
    minute: 'minuut',
    minutes: 'minuten',
    sensor_disconnected: 'sensor losgekoppeld',
    from: 'VAN',
    to: 'TOT',
    quick_start_guide: 'Snelstartgids',
    wet_outside: 'Natheid buiten luier',
    attend_fall: 'VAL BIJSTAAN',
    reclip_pod: 'POD OPNIEUW BEVESTIGEN',
    change_position: 'HOUDING WIJZIGEN',
    replace_battery: 'BATTERIJ VERVANGEN',
    allowed_time_exceeded: 'Toegestane tijd overschreden',
    wetness_outside: 'Natheid buitenkant',
    analysing_pad: '{pad} analyseren',
    pad_not_selected: '{pad} niet geselecteerd',
    silence: 'Dempen',
    silence_confirm_box_title: 'Valmelding dempen',
    silence_confirm_box_content:
      'Als u de valmelding dempt, wordt deze verwijderd uit het Groepsdashboard voor deze valgebeurtenis. Wilt u verdergaan? ',
    yes: 'JA',
    no: 'NEE',
    pad_status: 'STATUS VAN LUIER',
    check_pad_fill: 'LUIERVULLING CONTROLEREN',
    patient_profile: 'PROFIEL VAN DE {patient}',
    periods: 'Periodes',
    products: 'Producten',
    active: 'actief',
    manage_user_profile: 'Gebruikersprofiel beheren',
    sign_out: 'Afmelden',
    view: 'Bekijken',
    groups: 'groepen',
    groups_in_view: 'Groepen in beeld',
    total_daily_profile: 'Totaal dagelijks profiel',
    day_profile: 'Dagprofiel',
    night_profile: 'Nachtprofiel',
    pad_fill_profile_goal: 'DOEL VOOR {pad}',
    tap_to_setup_pad_fill_profile_goals: 'tikken om {pad} in te stellen',
    insufficient_data: 'Onvoldoende gegevens',
    last_7_days: 'Afgelopen 7 dagen',
    pad_removed: 'luier verwijderd',
    view_groups: 'Groep(en) bekijken',
    minimum_voiding_into_pad: 'Minimale urinelozing in {pad}',
    Monday: 'Maandag',
    Tuesday: 'Dinsdag',
    Wednesday: 'Woensdag',
    Thursday: 'Donderdag',
    Friday: 'Vrijdag',
    Saturday: 'Zaterdag',
    Sunday: 'Zondag',
    disconnected_desc:
      'wachten tot de pod opnieuw op de {pad} wordt geklikt...',
    pod_unclipped_desc: 'wachten tot de pod weer binnen bereik komt...',
    password_policy: 'Wachtwoordbeleid',
    position_chart: 'Houdingengrafiek',
    hi_everyone: 'Hoi allemaal,',
    voiding_chart_email_content:
      'De per e-mail verzonden Urinelozingsgrafiek (Voiding Chart) kan door u worden bekeken.',
    pad_fill_profile_chart_email_content:
      'De per e-mail verzonden {pad} (Pad Fill Profile Chart) kan door u worden bekeken.',
    position_chart_email_content:
      'De per e-mail verzonden Houdingengrafiek (Position Chart) kan door u worden bekeken.',
    temperature_chart_email_content:
      'De per e-mail verzonden Temperatuurgrafiek (Temperature Chart) kan door u worden bekeken.',
    heare_rate_chart_email_content:
      'De per e-mail verzonden Hartslaggrafiek (Heart Rate Chart) kan door u worden bekeken.',
    oximtry_chart_email_content:
      'De per e-mail verzonden Oximetriegrafiek (Oximetry Chart) kan door u worden bekeken.',
    respiration_chart_email_content:
      'De per e-mail verzonden Ademhalingsgrafiek (Respiration Chart) kan door u worden bekeken.',
    balance_chart_email_content:
      'De per e-mail verzonden Evenwichtsgrafiek (Balance Chart) kan door u worden bekeken.',
    smartz_chart_email_content:
      'De per e-mail verzonden Smartz™-grafiek kan door u worden bekeken.',
    best_regards: 'Met vriendelijke groet,',
    the_simavita_team: 'Het operationele team van Smartz Operations',
    days: 'dagen',
    weeks: 'weken',
    years: 'jaar',
    reset_all_users_passwords: 'Alle gebruikerswachtwoorden resetten',
    reset_all_passwords: 'Alle wachtwoorden resetten',
    reset: 'Resetten',
    change_password: 'Wachtwoord wijzigen',
    old_password: 'Oud wachtwoord',
    lowercase: 'Kleine letters',
    uppdercase: 'Hoofdletters',
    number: 'Number',
    please_select: 'Selecteer',
    loading_chart: 'Grafiek wordt geladen',
    please_wait: 'Een ogenblik geduld...',
    edit_user: 'Gebruiker bewerken',
    add_user: 'Gebruiker toevoegen',
    edit_group: 'Groep bewerken',
    add_group: 'Groep toevoegen',
    group_name: 'Groepsnaam',
    group_name_required: 'Groepsnaam is vereist',
    patients: '{patients}',
    manage_user_account: 'gebruikersaccount beheren',
    filter_by_group_name: 'filtreren op groepsnaam',
    delete_group_warning:
      'Houd er rekening mee dat het verwijderen van een groep definitief is.',
    delete_patient_warning:
      'Verwijderen van {patient}- en persoonsgegevens is permanent.',
    pod_mac: 'Mac van pod',
    pod_serial_number: 'Serienummer van pod',
    add_patient: '{patient} toevoegen',
    edit_patient: '{patient} bewerken',
    alias: 'Alias',
    alias_required: 'Alias is vereist',
    pod_mac_required: 'Mac van pod is vereist',
    pod_serial_number_required: 'Serienummer van pod is vereist',
    please_enter_capital_letters_and_numbers: 'Voer hoofdletters en cijfers in',
    select_date_range: 'Datumbereik selecteren',
    start_time: 'starttijd',
    end_time: 'eindtijd',
    select_groups_to_collate: 'Selecteer groep(en) om te rangschikken',
    all_groups: 'Alle groepen',
    export_report: 'Verslag exporteren',
    export_csv: 'CSV exporteren',
    reports: 'Verslagen',
    please_complete_form: 'Vul het formulier volledig in',
    nodes: 'Nodes',
    network_map: 'Netwerkkaart',
    network_utilisation: 'Netwerkgebruik',
    notify_me_when_nodes_offline: 'Laat me weten wanneer node(s) offline zijn',
    zoom_in_chart: 'Inzoomen op grafiek inschakelen',
    latency: 'Latentie',
    lan: 'LAN',
    wifi_infrastructure: 'Wifi-infrastructuur',
    standard_iot_network_map: 'Standaard IoT Netwerkkaart',
    pods: 'Pods',
    data: 'Gegevens',
    packet_less: 'Pakket minder',
    secondary_connection: 'Secundaire verbinding',
    rssi: 'RSSI',
    no_nodes: 'Geen nodes',
    share_code: 'Deelcode',
    //Start translation from here.
    active_patients: 'Actieve {patients}',
    archived_patients: 'Gearchiveerde {patients}',
    archive: 'archiveren',
    restore: 'herstellen',
    are_you_sure: 'Weet u het zeker?',
    you_about_to_archive: `U staat op het punt te archiveren`,
    default_group_not_delete: 'De standaard groep kan niet verwijderd worden',
    patients_belong_to: 'Patiënten behorend tot',
    move: 'Verplaatsen',
    warning: 'Waarschuwing',
    add_node: 'Node toevoegen',
    edit_node: 'Node bewerken',
    room_name: 'Kamernaam',
    mac_address: 'MAC-adres',
    delete_node_warning: 'Het verwijderen van de node is permanent. ',
    mac_address_required: 'MAC-adres is vereist',
    room_name_required: 'Kamernaam is vereist',
    mac_address_format_warning:
      'Het ingevoerde MAC-adresformaat is onjuist. Voer het in in de vorm van XX: XX:XX:XX:XX:XX:XX',
    connection_type: 'Verbindingstype',
    device_role: 'Apparaatrol',
    device_type: 'Apparaattype',
    offline: 'Offline',
    node_management: 'Nodebeheer',
    time_period: 'Duur',
    manufacturer: 'Fabrikant',
    product: 'Product',
    please_select_time_period: 'Selecteer een tijdsperiode',
    please_select_manufacturer: 'Selecteer de fabrikant',
    please_select_product: 'Selecteer een product',
    no_data: 'Geen gegevens',
    please_select_manufacturer_first: 'Selecteer eerst de fabrikant',
    details: 'Details',
    time_period_warning:
      'De dag- en nachttijd moeten de totale tijd van de dag gedurende 24 uur dekken.',
    reset_successfully: 'Opnieuw instellen is geslaagd',
    region: 'Regio',
    select_at_least_one_group: 'Selecteer ten minste één groep',
    node: 'Node',
    pods_location: 'Locatie pods',
    pod_id: 'Pod-id',
    accelerometer: 'Versnellingsmeter',
    senser: 'Sensor',
    gain: 'Versterking',
    offset: 'Verschuiving',
    failed_to_connecte_smartz_service:
      'Kan geen verbinding maken met Smartz<sup>®</sup>-service',
    add_to_smartz_group_failed: 'Toevoegen aan smartz-groepsservice mislukt',
    retry: 'Nogmaals proberen',
    customization: 'Aanpassing',
    customization_settings: 'Aanpassingsinstellingen',
    colors: 'Kleuren',
    font: 'Lettertype',
    logo: 'Logo',
    login_background: 'Inlogachtergrond',
    apply: 'Toepassen',
    theme: 'hen',
    to_current_site: 'naar huidige site',
    customize_theme_text:
      'Pas het uiterlijk van de site aan. Voelt u zich avontuurlijk?',
    create_a_custom_theme: 'Maak een aangepast thema',
    custom_theme: 'Aangepast thema',
    preview: 'voorbeeld',
    reset_customization_settings:
      'Alle configuraties zijn teruggezet naar standaard',
    drag_the_logo_here: 'Sleep het logo hierheen',
    or: 'of',
    click_upload: 'klik op uploaden',
    only_image_files_can_be_uploaded:
      'Alleen JPG-/PNG-bestanden kunnen worden geüpload',
    the_size_of_the_uploaded_image_cannot_exceed:
      'De grootte van de geüploade afbeelding mag niet groter zijn dan 2 MB',
    please_sign_out_to_preveiw_effect:
      'Meld u na het uploaden af om een voorbeeld van het effect te bekijken',
    please_enter_theme_name: 'Voer de themanaam in',
    failed: 'Mislukt',
    add_pod: 'Pod toevoegen',
    edit_pod: 'Pod bewerken',
    filter_pod: 'Filteren op mac-adres van pod',
    filter_node: 'Filteren op node, MAC-adres en kamer',
    delete_pod_warning: 'Het verwijderen van de pod is permanent. ',
    delete_theme_warning: 'Het verwijderen van het thema is permanent.',
    apply_theme_warning:
      'Opmerking: deze bewerking past de aangepaste instellingen toe op de domeinnaam. Wees voorzichtig.',
    please_enter_domain_name: 'Voer de domeinnaam in',
    domain_name_incorrect: 'De indeling van de domeinnaam is onjuist',
    apply_successfully: 'Succesvol toegepast',
    location: 'Locatie',
    manufacturer_code: 'Fabrikantencode',
    node_mac_address: 'MAC-adres van node',
    expired: 'Verlopen',
    please_select_location: 'Selecteer locatie.',
    filter_patients: '{patients} filteren',
    monitor_patient: '{patient} monitoren',
    patient: '{patient}',
    room: 'Kamer',
    assign: 'Toewijzen',
    unassign: 'Toewijzing opheffen',
    unassign_patient_permanent:
      'Houd er rekening mee dat de toewijzing van de patiënt permanent is.',
    you_able_to_unassign: `U staat op het punt de toewijzing ongedaan te maken`,
    node_mac_address_required: 'MAC-adres van node s vereist',
    not_assigned: 'Niet toegewezen',
    assign_node_to: 'Node toewijzen aan',
    create_user: 'Gebruiker aanmaken',
    email_is_required: 'E-mailadres is vereist',
    created_successfully: 'Met succes aangemaakt',
    manage_patient_data: '{patient} BEHEREN',
    selected_patient: 'GESELECTEERDE {patient}',
    archive_patient: '{patient} ARCHIVEREN',
    archive_patient_warning:
      '{patient} archiveren. De {patient} zal niet langer op het systeem verschijnen totdat ze zijn hersteld.',
    archive_patient_data: '{patient} archiveren',
    restore_patient: '{patient} herstellen',
    restore_patient_warning:
      'Herstel gearchiveerde gegevens zodat deze op dit systeem kunnen worden bekeken.',
    archive_date: 'Archiveerdatum',
    restore_patient_data: '{patient} herstellen',
    delete_account: 'ACCOUNT VERWIJDEREN',
    user_accounts: 'Gebruikersaccounts',
    selected_site: 'Geselecteerde site',
    no_site: 'Geen site',
    drag_the_login_background_here: 'Sleep de inlogachtergrond hierheen',
    drag_the_menu_background_here: 'Sleep de menu-achtergrond hierheen',
    patient_data_privacy: 'PRIVACY VAN PATIËNTGEGEVENS',
    edit_theme: 'Thema bewerken',
    drag_the_main_content_background_here:
      'Sleep de achtergrond van de hoofdinhoud hierheen',
    opacity_desc:
      'Opaciteit (transparantie van inhoud in de wacht op de achtergrond)',
    menu_bg: 'Menu-achtergrond',
    main_content_bg: 'Achtergrond hoofdinhoud',
    background: 'Achtergrond',
    account: 'account',
    super_admin: 'superbeheerder',
    help: 'Help',
    filter_by_user_name: 'filter op gebruiker',
    drag_the_top_nav_background_here:
      'Sleep de bovenste navigatie-achtergrond hierheen',
    apply_theme: 'Thema toepassen',
    apply_to_this_domain: 'Toepassen op dit domein',
    crop_image: 'Afbeelding bijsnijden',
    enlarge: 'Vergroten',
    narrow: 'Smal',
    left_rotation: 'Linksom draaien',
    right_rotation: 'Rechtsom draaien',
    remove_image: 'Afbeelding verwijderen',
    operation_area: 'Operatiegebied',
    preview_area: 'Voorbeeldgebied',
    logo_shape: 'Logovorm',
    show_as_circle: 'Als cirkel weergeven',
    history: 'Geschiedenis',
    status: 'Status',
    download: 'Downloaden',
    export: 'Exporteren',
    created_date: 'Datum gemaakt',
    next: 'Volgende',
    register: 'Registreren',
    back: 'Terug',
    create_an_organisation: 'Een Organisatie aanmaken',
    please_enter_organisation_name: 'Voer de naam van de organisatie in',
    address: 'Adres',
    please_enter_organisation_address: 'Voer organisatieadres in',
    phone: 'Telefoon',
    please_enter_organisation_phone:
      'Voer het telefoonnummer van de organisatie in',
    description: 'Beschrijving',
    add_facility: 'Faciliteit toevoegen',
    edit_facility: 'Faciliteit bewerken',
    facility: 'Faciliteit',
    no_room: 'Geen kamer',
    facility_name: 'Naam faciliteit',
    add_room: 'Kamer toevoegen',
    room_already_exists: 'De kamer bestaat al',
    home: 'start',
    signed_into: 'Aangemeld bij',
    please_select_an_organisation: 'Selecteer een organisatie',
    hello: 'Hallo',
    useful_features: 'Handige functies',
    attention: 'Let op',
    quick_actions: 'Snelle acties',
    no_patient_warning:
      'Er zijn geen {patients} om te monitoren. Voeg nu {patients} toe om aan de slag te gaan.',
    add_patient_quick_action_desc:
      'Voeg een {patient} toe die gemonitored moet worden',
    welcome_to_the_group_dashboard: 'Welkom bij het Groepsdashboard',
    show_me_more: 'Meer weergeven',
    add: 'toevoegen',
    welcome_to_patient_management: 'Welkom bij Patiëntenbeheer',
    update_patient: '{patient} bijwerken',
    update_patient_quick_action_desc: `{patient} bijwerken`,
    change_patient_products: `Producten van de {patient} wijzigen`,
    change_patient_products_quick_action_desc:
      'Wijzig het product dat door de {patient} wordt gebruikt',
    reassign_pod_to_patient: 'Pod opnieuw toewijzen aan {patient}',
    reassign_pod_quick_action_desc: `Pod van de {patient} wijzigen`,
    monitor_patient_with_a_node: 'Node toewijzen aan {patient}',
    monitor_patient_with_a_node_quick_action_desc:
      'Node van een {patient} beoordelen',
    welcome_to_the_administration_section:
      'Welkom bij de afdeling Administratie',
    invite_user: 'Gebruiker uitnodigen',
    invite_user_quick_action_desc: 'Een gebruiker uitnodigen voor het systeem',
    remove_or_archive_patient: '{patient} verwijderen/archiveren',
    remove_or_archive_patient_quick_action_desc:
      'Een {patient} uit het dashboard verwijderen',
    profile: 'Profiel',
    not_monitored: 'niet gemonitord',
    rounds: 'Rondes',
    //translate permissions list
    'Super Admin': 'Superbeheerder',
    Algorithms: 'Algoritmes',
    Customisation: 'Personalisatie',
    Account: 'Account',
    'Roles & Permissions': 'Rollen en machtigingen',
    'Network Map': 'Netwerkkaart',
    'Network Utilisation': 'Netwerkgebruik',
    'Buildings & Rooms': 'Faciliteiten en kamers',
    Manufacturers: 'Fabrikanten',
    Settings: 'Instellingen',
    Profile: 'Profiel',
    Devices: 'Hulpmiddelen',
    Nodes: 'Nodes',
    'Pods Location': 'Locatie pods',
    'Share Code': 'Deelcode',
    Users: 'Gebruikers',
    'User Accounts': 'Gebruikersaccounts',
    'Invite User': 'Gebruiker uitnodigen',
    Patients: 'Patiënten',
    'Monitor Patient': 'Patiënten monitoren',
    'Patient Data Privacy': 'Privacy van patiëntgegevens',
    Archive: 'Archiveren',
    Restore: 'Herstellen',
    'Patients Module': 'Patiëntenmodule',
    Export: 'Exporteren',
    History: 'Geschiedenis',
    Report: 'Rapporteren',
    Monitor: 'Monitoren',
    //translate permissions list
    time_zone: 'Tijdzone',
    please_select_time_zone: 'Selecteer een tijdzone',
    add_facility_and_room: 'FACILITEIT EN KAMER TOEVOEGEN',
    filter_by_facility_name: 'filteren op naam van faciliteit',
    floor: 'Verdieping',
    please_enter_facility_name: 'Voer de naam van de faciliteit in',
    please_enter_floor_name: 'Voer de naam van de verdieping in',
    please_enter_room_number: 'Vul een kamernummer in',
    facility_name_already_exists: 'Naam van faciliteit bestaat al',
    floor_name_should_be_unique: 'Verdiepingnaam moet uniek zijn',
    room_number_should_be_unique: 'Kamernummer moet uniek zijn',
    add_manufacturer: 'Fabrikant toevoegen',
    filter_by_manufacturer_code_or_name: 'filteren op fabrikantcode of naam',
    enabled: 'Ingeschakeld',
    delete_manufacturer_warning: 'Verwijderen van de fabrikant is permanent. ',
    please_enter_role_name: 'Voer een rolnaam in',
    please_choose_one_as_the_current_organization:
      'Kies er een als de huidige organisatie',
    display_name: 'Weergavenaam',
    assign_roles: 'Rollen toewijzen',
    remove: 'Verwijderen',
    please_assign_a_role_to_the_user: 'Wijs een rol toe aan de gebruiker',
    send_invitation: 'uitnodiging sturen',
    invitation_email_sent: 'Uitnodigingsmail verzonden.',
    facility_and_Floor_and_Room: 'Faciliteit, verdieping en kamer',
    export_patient: '{patient} exporteren',
    export_patient_history_data: 'Gegevens over {patient} exporteren',
    export_patient_data: '{patient} exporteren',
    export_report_success_text: `{patient} worden geëxporteerd. U wordt per e-mail op de hoogte gesteld wanneer deze beschikbaar is. Controleer de voortgang op het tabblad bestanden. `,
    select_patients: '{patients} selecteren',
    export_in_progress: 'Bezig met exporteren',
    continue: 'doorgaan',
    please_enter_patient_name: `Voer de naam van de {patient} in`,
    please_enter_patient_alias: `Voer de alias van de {patient} in`,
    facility_and_room: 'Faciliteit en kamer',
    create_new: 'Nieuw aanmaken',
    add_facility_and_floor_and_room:
      'Faciliteit, verdieping en kamer toevoegen',
    select_facility_floor_room: 'Faciliteit, verdieping en kamer selecteren',
    choose_one: 'Kies één',
    enter_manually: 'Handmatig invullen',
    pod_serial_number_format_incorrect:
      'Indeling ingevoerd pod-serienummer is onjuist.',
    add_a_manufacturer_to_continue: 'Voeg een fabrikant toe om door te gaan',
    please_enter_subscription_code: 'Voer de abonnementscode in',
    added_successfully: 'Met succes toegevoegd',
    select_a_patient: 'Selecteer een {patient}',
    assign_products: 'Producten toewijzen',
    assign_pod: 'Pod toewijzen',
    assign_node: 'Node toewijzen',
    we_have_created_a_default_facility:
      'we hebben een standaardfaciliteit, -verdieping en -kamer voor uw organisatie gecreëerd',
    if_you_want_edit_this_facility: `Als u de informatie van deze faciliteit wilt bewerken, tikt u op`,
    or_you_can: 'Of u kunt',
    already_registered: 'Al geregistreerd',
    sign_up: 'Registreren',
    create_account: 'Account aanmaken',
    pod_and_diaper: 'Pod en {pad}',
    pod_and_diaper_content: ` <p class="underline">Volg deze stappen om de pod aan te sluiten op de {pad}:</p>
          <ul>
            <li>
            Lijn de drie strepen op de Smart-{pad} met de drie gouden pinnen op de Smart-pod
            </li>
            <li>Klem de pod vast <span class="underline">aan de voorkant</span> van de Smart-{pad}</li>
            <li>
            Groen lampje knippert snel gedurende 3 seconden, daarna vast gedurende 1 seconde = goede verbinding
            </li>
            <li>
            Geen knipperend groen licht na 20 seconden = geen verbinding. De Smart-pod ontgrendelen en herbevestigen
            </li>
            <li>Als er geen lampje knippert met de juiste verbinding, dan is de accu leeg</li>
          </ul>`,
    home_landing_slide1_title: 'Welkom bij het Gezondheidsportaal',
    home_landing_slide1_content: `
      <p>Met het Gezondheidsportaal kunt u de continentie en het welzijn van uw {patient} monitoren.</p>
      <p>Monitoren van groepen {patients} om acties te prioriteren en individuele gecentreerde zorg te bieden.</p>`,
    home_landing_slide2_title: 'Smart-luiertechnologie',
    home_landing_slide2_content: `
      <p>Wanneer een Smart-pod is aangesloten op een Smart-{pad}, verzendt deze gegevens via een netwerk waarmee de verzorger de {patient} kan controleren via het Gezondheidsportaal.</p>
      <p>Zodra uw {patient} is toegewezen in het systeem, weet u in één oogopslag wanneer u de {pad} moet vervangen en historische gegevens moet bekijken. U kunt ook gemakkelijk doelen stellen en op de hoogte worden gesteld van wanneer u de {pad} moet vervangen, de houding van uw {patient}, de vloeistofuitvoer controleren, de omgevingstemperatuur en mogelijke vallen monitoren.</p>`,
    home_landing_slide4_title: 'Eerste {patient} toevoegen',
    home_landing_slide4_content: `
      <p>Om te beginnen voegt u een {patient} toe met behulp van de knop Snelle actie en volgt u de aanwijzingen.</p>
      <p>Het systeem zal u helpen bij het instelproces van de {patient}.</p>`,
    home_landing_slide5_title: 'Snelle acties',
    home_landing_slide5_content: `
      <p>Hiermee hebt u toegang tot frequente acties zoals het toevoegen van een {patient}.</p>
      <p>Een wizard begeleidt u door alle benodigde stappen. </p>`,
    dashboard_landing_slide1_title: 'Welkom bij het Groepsdashboard',
    dashboard_landing_slide1_content: `
      <p>Controleer al uw {patients} op het Dashboard en weet wanneer uw {patients} aandacht nodig hebben.</p>
      <p>Uw werklast kan worden verminderd door de visuele aanwijzingen van het systeem te volgen.</p>`,
    dashboard_landing_slide2_title: 'Welkom bij het Groepsdashboard',
    dashboard_landing_slide2_content: `<ul>
      <li>Pictogrammen worden weergegeven om de status van de {patient} aan te geven</li>
      <li>Er zijn twee secties op het Dashboard, een sectie <span class="underline">Actie vereist</span> en een sectie <span class="underline">Monitoren</span></li>
      <li>Om de werkdruk te verminderen en de {patient} te verbeteren, moet u de pictogrammen <span class="under'Actie vereist'line"></span> met hoge prioriteit gebruiken</li>
    </ul>`,
    dashboard_landing_slide3_title: 'De {pad} statussen',
    dashboard_landing_slide3_content: `
      <p>De {pad} status en 'Tijd om te verschonen' wordt weergegeven door een verkeerslichtsysteem:</p>
      <ul>
        <li><span class="red-text"><span class="underline">Rood</span> = {pad} verschonen</span> d.w.z. natte {pad} met risico op lekkage</li>
        <li><span class="yellow-text"><span class="underline">Geel</span> = voorbereiden om {pad} te verschonen</span>, d.w.z. {pad} bereikt capaciteit</li>
        <li><span class="green-text"><span class="underline">Groen</span> = geen actie</span> d.w.z. droge {pad}</li>
      </ul>`,
    dashboard_landing_slide4_title: 'Overige statussen',
    dashboard_landing_slide4_content: `
      <p>Om de continuïteit van de zorg te waarborgen, dient u alle acties op het dashboard te volgen:</p>
      <ul>
        <li>Het symbool 'Verbinding verbroken' geeft aan dat de Bluetooth-verbinding is verbroken en dat er mogelijk gegevens verloren gaan.</li>
        <li>Het symbool 'houding wijzigen' geeft aan dat het tijd is om de houding van de {patient} te wijzigen.</li>
      </ul>`,
    dashboard_landing_slide5_title: 'Optimaliseren',
    dashboard_landing_slide5_content: `<p>Bekijk de meldingen in het groepsdashboard om uw dagelijkse {patient} te optimaliseren.</p>`,
    dashboard_landing_slide6_title: 'Gebiedsfilters',
    dashboard_landing_slide6_content: `
      <p>Het gebiedsfilter is een optionele functie waarmee u een geselecteerd gebied op uw dashboard van de faciliteit kunt bekijken. Gebruik de gebiedsfilters met de nodige voorzichtigheid, omdat het bestaande {patients} verbergt en alleen de filterselecties weergeeft.</p>
      <p>Ga als volgt te werk om het filter voor het nieuwe gebied te kiezen: </p>
      <ol>
        <li>Selecteer het vervolgkeuzemenu van het gebied</li>
        <li>Tik op 'Nieuw gebied'</li>
        <li>Typ de 'Naam gebiedsfilter'</li>
        <li>Selecteer het gebouw</li>
        <li>Vink het gebied, de verdieping en de kamernummers aan</li>
        <li>Controleer uw filterselectie in het filteroverzichtsvak</li>
        <li>Tik om dit gebiedsfilter op te slaan</li>
        <li>Selecteer gebiedsfilter of 'Gebieden beheren' in de vervolgkeuzelijst</li>
      </ol>
    `,
    home_landing_slide3_title: 'Pod en {pad}',
    home_landing_slide3_content: `
    <ul>
      <li>Sluit de pod aan op de {pad}</li>
      <li>Bekijk de groene ledlampjes op de pod</li>
      <li>Ontvang updates over de status van de {patient}</li>
    </ul>`,
    patient_landing_slide1_title: 'Individueel dashboard',
    patient_landing_slide1_content: `
      <p>Als u een individuele {patient} selecteert, geeft een nieuw dashboard de status weer van alle functies die momenteel worden gecontroleerd, inclusief Smart-pod en -{pad} die in gebruik zijn.</p>
      <p>Kies een andere {patient} om weer te gegeven in het vervolgkeuzemenu.</p>`,
    patient_landing_slide2_title: `Welkom bij de sectie {patient}`,
    patient_landing_slide2_content: `
      <p>Het Individuele Dashboard geeft de huidige status van de {patient} aan.</p>
      <p>De sectie Grafieken legt gezondheidstrends vast.</p>
      <p>Specifieke doelen kunnen worden ingesteld in het gedeelte Doelen en ontvangen meldingen.</p>`,
    patient_landing_slide3_title:
      'Toegang tot het Individuele Dashboard, Grafieken en Doelen',
    patient_landing_slide3_content: `<p>Aan de linkerkant van het Dashboard heeft u toegang tot de sectie {patient}, Grafieken en Doelen.</p>`,
    patient_landing_slide4_title: '{patient} / Individueel Dashboard',
    patient_landing_slide4_content: `
      <ul>
        <li>Elke {patient} heeft zijn eigen Individuele Dashboard</li>
        <li>Verdiep u verder in de individuele status van uw {patient}</li>
        <li>Schakel tussen {patients} door te selecteren uit de vervolgkeuzelijst</li>
      </ul>`,
    patient_landing_slide5_title: 'Grafieken',
    patient_landing_slide5_content: `
      <p>Er zijn verschillende grafieken waarmee u gegevens kunt bekijken en interpreteren, waaronder:</p>
      <ul>
        <li>Urinelozingsgrafiek</li>
        <li>{pad} vullingprofiel</li>
        <li>Houdingengrafiek.</li>
      </ul>
      <p>U kunt deze afdrukken en delen om de zorg van uw {patient} te bekijken en aan te passen.</p>`,
    patient_landing_slide6_title: 'Doelen',
    patient_landing_slide6_content: `
      <p>Om de zorg voor uw {patient} verder te verbeteren, kunnen specifieke doelen worden gesteld. Dit zijn o.a.:</p>
      <ul>
        <li>Lichaamsherpositionering</li>
        <li>Huidverzorging</li>
        <li>{pad} vullingprofiel</li>
        <li>Temperatuur</li>
        <li>Vallen.</li>
      </ul>`,
    common_help_content: `
      <ul>
        <li>Kies welke {patient} u wilt bekijken met behulp van het vervolgkeuzemenu.</li>
      </ul>`,
    chart_common_slide_content: `
      <ul>
        <li>Door het datumbereik te selecteren, kunnen maximaal 7 dagen worden weergegeven.</li>
      </ul>`,
    voiding_chart_slide1_content: `
      <ul>
        <li>De urinelozingsgrafiek geeft een holistisch overzicht van de geschiedenis van de urinelozing van uw {patients}.</li>
        <li>Realtime gegevens worden weergegeven op de urinelozingsgrafiek bij gebruik van het Smartz<sup>®</sup>-systeem.</li>
        <li>In deze grafiek kunt u schakelen tussen het bekijken van de {pad} cyclus of het overzicht van gebeurtenissen die vervallen.</li>
      </ul>`,
    voiding_chart_slide4_content: `
      <ul>
        <li>Pictogrammen kunnen worden gefilterd op selectie.</li>
        <li>De legenda onder de urinelozingsgrafiek toont de pictogrammen die op de grafiek worden weergegeven.</li>
        <li>Tik op 'grafiekfilters' om de pictogrammen die u wilt bekijken te selecteren of deselecteren.</li>
      </ul>`,
    voiding_chart_slide5_content: `
      <p>Door dit diagram te bekijken, kunt u:</p>
      <ul>
        <li>potentiële tijden identificeren waarop de {patient} met succes naar het toilet kan gaan</li>
        <li>of de {pad} binnen een aanvaardbare termijn is vervangen</li>
        <li>het aantal {pad} verschoningen over de periode</li>
        <li>uw grafiek delen en afdrukken.</li>
      </ul>`,
    smartz_events_slide1_content: `
      <ul>
        <li>De Gebeurtenissengrafiek toont alle gebeurtenissen voor {pad}-, pod-, doel- en netwerkstatussen.</li>
      </ul>`,
    pad_fill_profile_chart_slide1_content: `
      <ul>
        <li>Het 'Totaal dagelijks-profiel' geeft de totale hoeveelheid vloeistof weer die gedurende een periode van 24 uur in de {pad} is vrijgekomen.</li>
        <li>De dagelijkse urineproductie in de {pad} wordt boven elke druppel weergegeven.</li>
      </ul>`,
    pad_fill_profile_chart_slide4_content: `
      <ul>
        <li>Het pictogram aan de rechterkant geeft de 'Gemiddelde' volume van de urineproductie over de geselecteerde periode van een aantal dagen aan.</li>
        <li>Omschakelen om de 'Dag'- en 'Nacht'-profielen afzonderlijk te zien.</li>
        <li>De grafiek geeft aan of er een {pad}vullingprofiel-doel is ingesteld of geactiveerd.</li>
        <li>Kies indien nodig om het doel in te stellen.</li>
      </ul>`,
    pad_fill_profile_chart_slide5_content: `
      <ul>
        <li>Het totale dagelijkse profiel toont de totale hoeveelheid vloeistof die in de {pad} is gegaan gedurende een periode van 24 uur.</li>
        <li>Als de {patient} een vermindering van de urineproductie heeft, kan dit een indicator zijn om de hydratatie te verhogen.</li>
        <li>Uw grafiek delen en afdrukken.</li>
      </ul>`,
    body_position_chart_slide1_content: `
      <ul>
        <li>De grafiek toont de lengte van de tijd in een lichaamshouding over een geselecteerd aantal dagen.</li>
        <li>Als u meer details wilt zien, beweegt u de muis over de grafiek.</li>
      </ul>`,
    body_position_chart_slide4_content: `
      <ul>
        <li>Tik op 'grafiekfilters' om de houdingen die u wilt weergeven te selecteren of deselecteren.</li>
        <li>De grafiek licht uit of er een lichaamshoudingsdoel is ingesteld.</li>
        <li>Tik om het doel in te stellen.</li>
      </ul>`,
    body_position_chart_slide5_content: `
      <ul>
        <li>Als u een {patient} heeft die gevoelig is voor huidbeschadiging/decubitus, wordt u door het instellen van het doel op de hoogte gesteld van de tijd om de houding van de {patient} te wijzigen.</li>
        <li>Wanneer 'afdrukken' is geselecteerd, worden de houdings en de tijdsperiodes in meer detail weergegeven. </li>
      </ul>`,
    goal_common_slide_content: `
      <ul>
        <li>Controleer de gloeilampsectie voor meer details.</li>
      </ul>`,
    body_position_goal_help_title: 'Doel van lichaamsherpositionering',
    body_position_goal_slide1_content: `
      <ul>
        <li>Door het doel te stellen, wordt de verzorger op de hoogte gebracht van de tijd om de houding van de {patient} te wijzigen.</li>
        <li>Gebruik dit doel als u een {patient} heeft die gevoelig is voor huidbeschadiging/decubitus.</li>
        <li>Het verminderen van de tijd in één houding kan helpen om decubitus te verminderen.</li>
      </ul>`,
    body_position_goal_slide2_content: `
      <ul>
        <li>Kies welke {patient} u wilt bekijken met behulp van het vervolgkeuzemenu.</li>
        <li>Beweeg de schuifregelaar om de maximale tijdsduur te kiezen die u wilt dat uw {patient} op één houding ligt, hetzij overdag en/of 's nachts.</li>
        <li>Tik om het doel op te slaan.</li>
      </ul>`,
    body_position_goal_slide3_content: `
      <ul>
        <li>U hebt nu de maximale tijdsduur voor uw {patient} geselecteerd om in één houding te liggen en u krijgt een melding in het gedeelte 'Actie vereist' wanneer u moet wijzigen.</li>
      </ul>`,
    skin_management_goal_help_title: 'Doel van huidbeheer',
    skin_management_goal_slide1_content: `
      <ul>
        <li>Het regelmatig verschonen van de {pad} kan helpen om de huid van de {patient} droog te houden en huidirritaties te verminderen.</li>
      </ul>`,
    skin_management_goal_slide2_content: `
      <ul>
        <li>Kies welke {patient} u wilt bekijken met behulp van het vervolgkeuzemenu.</li>
        <li>Verplaats de schuifregelaar om de maximale tijdsduur te selecteren die uw {patient} in een {pad} moet doorbrengen.</li>
        <li>Tik om het doel op te slaan.</li>
      </ul>`,
    skin_management_goal_slide3_content: `
      <ul>
        <li>U krijgt nu een melding in het gedeelte 'Actie vereist' wanneer u de {pad} van de {patient} moet verschonen.</li>
      </ul>`,
    pod_temperature_goal_help_title: 'Pod-omgevingstemperatuur',
    pod_temperature_goal_slide1_content: `
      <ul>
        <li>Met dit doel kunt u de minimale / maximale omgevingstemperatuur van de pod instellen.</li>
        <li>Stel dit doel in als u zich zorgen maakt over de temperatuurschommelingen van uw {patient}.</li>
      </ul>`,
    pod_temperature_goal_slide2_content: `
      <ul>
        <li>Kies welke {patient} u wilt bekijken met behulp van het vervolgkeuzemenu.</li>
        <li>Beweeg de schuifregelaar om de minimum- en maximumtemperatuur te kiezen om op de hoogte te worden gebracht van eventuele veranderingen in de temperatuur rond de pod.</li>
        <li>Tik om het doel op te slaan.</li>
      </ul>`,
    pod_temperature_goal_slide3_content: `
      <ul>
        <li>U krijgt nu een melding in het gedeelte 'Actie vereist' wanneer de omgevingstemperatuur van de pod buiten het ingestelde bereik valt.</li>
      </ul>`,
    pad_fill_profile_goal_help_title: 'Doel voor {pad}vullingprofiel',
    pad_fill_profile_goal_slide1_content: `
      <ul>
        <li>Met dit doel kunt u het minimale / maximale lozingsvolume in de {pad} instellen als u bang bent dat uw {patient} een lage urineproductie heeft.</li>
      </ul>`,
    pad_fill_profile_goal_slide2_content: `
      <ul>
        <li>Kies welke {patient} u wilt bekijken met behulp van het vervolgkeuzemenu.</li>
        <li>Verplaats de schuifregelaar om het gewenste volume voor dag en / of nacht te selecteren.</li>
        <li>Tik om het doel op te slaan.</li>
      </ul>`,
    pad_fill_profile_goal_slide3_content: `
      <ul>
        <li>U krijgt nu een melding in het gedeelte 'Actie vereist' wanneer het urineproductievolume van uw {patient} in de {pad} buiten het ingestelde bereik valt.</li>
      </ul>`,
    fall_detection_goal_help_title: 'Doel van valdetectie',
    fall_detection_goal_slide1_content: `
      <ul>
        <li>Dit doel zal u op de hoogte brengen als uw {patient} is gevallen.</li>
      </ul>`,
    fall_detection_goal_slide2_content: `
      <ul>
        <li>Kies welke {patient} u wilt bekijken met behulp van het vervolgkeuzemenu.</li>
        <li>Verplaats de schuifregelaar naar de AAN-positie om het doel te activeren.</li>
        <li>Standaard is de Tijd in houding ingeschakeld. </li>
        <li>Tik om het doel op te slaan.</li>
      </ul>`,
    fall_detection_goal_slide3_content: `
      <ul>
        <li>Als er een val is opgetreden, wordt een knipperend pictogram weergegeven in het gedeelte 'Actie vereist'.</li>
        <li>Als u de val in het 'Individuele Dashboard' dempt, wordt het pictogram uit het hoofddashboard verwijderd.</li>
      </ul>`,
    voiding_chart_help_dialog_title: 'De urinelozingsgrafiek gebruiken',
    pad_fill_profile_chart_help_dialog_title:
      'Het {pad}vullingprofiel gebruiken',
    position_chart_help_dialog_title: 'De lichaamshoudinggrafiek gebruiken',
    pad_fill_profile_goal_help_dialog_title:
      'Doel voor {pad}vullingprofiel instellen',
    skin_care_goal_help_dialog_title: 'Doel voor huidzorgbeheer instellen',
    position_goal_help_dialog_title:
      'Instellen van het doel voor lichaamsherpositionering',
    temperature_goal_help_dialog_title:
      'Doel voor pod-omgevingstemperatuur instellen',
    fall_detection_goal_help_dialog_title: 'Doel voor valdetectie instellen',
    invite_user_quick_action_desc_for_home_landing:
      'Nodig een zorgverlener uit om lid te worden van deze organisatie',
    archived_successfully: 'Succesvol gearchiveerd',
    verification_passed: 'Verificatie geslaagd',
    verification_failed: 'Verificatie is mislukt',
    verify_error_msg_801:
      'Uw uitnodiging is verlopen of niet meer geldig. Neem contact op met de beheerder van de organisatie om een nieuwe uitnodiging aan te vragen.',
    verify_error_msg_802:
      'Uw uitnodiging is niet geldig voor deze gebruiker. Als u bent ingelogd als een andere gebruiker voordat u deze uitnodiging accepteerde. Log uit en probeer het opnieuw.',
    verify_error_msg_803: 'Gebruiker niet gevonden.',
    verify_error_msg_804: 'Uitnodigingscode niet gevonden.',
    verify_error_msg_805:
      'U bent al lid van de organisatie waar u lid van wilt worden.',
    verify_success_msg: 'Welkom bij de nieuwe organisatie.',
    verify_error_msg_not_sign_in: `Meld u aan om lid te worden van de organisatie. <br/> Als u nog geen account heeft, meld u dan eerst aan.`,
    verify_error_msg_620: 'De code is ongeldig of is verlopen',
    verify_error_msg_622: `Kan niet lid worden van de organisatie. De uitnodigingscode is niet geldig voor dit e-mailadres.`,
    failed_to_get_chart_data: 'Grafiekgegevens konden niet worden verzonden.',
    filter: 'Filteren',
    please_select_facility_first: 'Selecteer eerst de faciliteit',
    areas: 'Gebied(en)',
    floors: 'Verdieping(en)',
    new_area: 'Nieuw gebied',
    manage_areas: 'Gebieden beheren',
    show_all_facilities: 'Alle faciliteiten weergeven',
    show_all_areas: 'Alle gebieden weergeven',
    new_area_filter: 'Nieuw gebiedsfilter',
    area_filter_name: 'Naam gebiedsfilter',
    area: 'Gebied',
    please_enter_area_filter_name: 'Geef de naam van het gebiedsfilter op',
    please_select_facility: 'Selecteer de faciliteit',
    please_select_floor_and_room: 'Selecteer verdieping en kamer',
    please_select_organisation: 'Selecteer organisatie',
    filter_summary: 'Filtersamenvatting',
    show_patients_from: '{patients} weergeven van',
    in: 'in',
    and: 'en',
    belonging_to: 'behorend bij',
    select_an_area: 'Selecteer een gebied',
    manage_area: 'Gebied beheren',
    please_select_area_filter: 'Selecteer een gebiedsfilter',
    delete_area: 'Gebied verwijderen',
    keep_in_mind_delete_area:
      'Het verwijderen van het gebied zal permanent zijn. ',
    facility_information: 'Faciliteitgegevens',
    floor_information: 'Informatie over verdieping',
    room_information: 'Informatie over kamer',
    number_of_floors: 'Aantal verdiepingen',
    please_enter_number_of_floors: 'Voer het aantal verdiepingen in',
    number_of_rooms: 'Aantal kamers',
    please_enter_number_of_rooms: 'Geef het aantal kamers op.',
    add_floor: 'Verdieping toevoegen',
    remove_floor: 'Verdieping verwijderen',
    remove_room: 'Kamer verwijderen',
    select_area_warning: `Het gebied en de verdieping kunnen niet tegelijkertijd worden geselecteerd. <br/>Selecteer één.`,
    manage_area_filter: 'Gebiedsfilter beheren',
    no_area: 'Geen gebied',
    there_are_no_patient_to_manage: 'Er zijn geen {patients} om te beheren.',
    default_themes: `Standaard thema's`,
    custom_themes: `Aangepaste thema's`,
    background_color: 'Achtergrond kleur',
    top_navigation_background_color: 'Hoofdnavigatie achtergrondkleur',
    top_nav_text_color: 'Hoofdnavigatie tekstkleur',
    top_nav_active_text_color: 'Hoofdnavigatie actieve tekstkleur',
    sidebar_background_color: 'Zijbalk achtergrondkleur',
    sidebar_active_block_background_color:
      'Zijbalk actief blok achtergrondkleur',
    sidebar_text_color: 'Zijbalk tekstkleur',
    sidbar_active_block_text_color: 'Zijbalk actief blok tekstkleur',
    card_title_background_color: 'Kaarttitel achtergrondkleur',
    card_title_text_color: 'Kaarttitel tekstkleur',
    card_body_background_color: 'Kaart body achtegrondkleur',
    card_button_color: 'Kaart knop kleur',
    room_number: 'Kamernummer',
    verify_invitation: 'UITNODIGING VERIFIËREN',
    well_done: 'Goed gedaan!',
    you_have_updated_the_patient: `U heeft de gegevens van de {patient} bijgewerkt.`,
    you_have_created_the_patient:
      'U hebt een {patient} toegevoegd die kan worden bekeken op het groepsdashboard.',
    tell_me_more: 'Vertel me wat meer',
    registered_pods: 'Geregistreerde pods',
    registered_nodes: 'Geregistreerde nodes',
    select: 'Selecteren',
    start: 'Starten',
    end: 'Einde',
    floor_name: 'Naam verdieping',
    sign_in_failed: 'Aanmelden mislukt',
    skin_care_goal_title: 'Tijd in {pad}',
    time_in_wet_pad: 'Tijd in natte {pad}',
    'Event Chart': 'Smartz-gebeurtenisdiagram',
    account_information: 'Accountgegevens',
    given_name: 'Voornaam',
    surname: 'Achternaam',
    please_enter_pod_serial_number: 'Voer het pod-serienummer in',
    manufacturer_subscription_code: `Abonnementscode van de fabrikant`,
    remove_node_mac_address: 'Mac-adres van node verwijderen',
    link_a_node_mac_address: 'Een mac-adres van een node koppelen',
    export_data: 'Gegevens exporteren',
    available_files: 'Beschikbare bestanden',
    export_patient_data_desc:
      'Klik op de volgende knop om de historische gegevens van te exporteren',
    dry_diaper: 'Droge {pad}',
    wet_diaper: 'Natte {pad}',
    change_diaper: '{pad} verschonen',
    external_humidity: 'Externe vochtigheid',
    smartz_events: 'Smartz<sup>®</sup>-gebeurtenissen',
    smartz_events_chart_email_content:
      'De per e-mail verzonden Gebeurtenisgrafiek kan door u worden bekeken.',
    reposition: 'Herpositioneren',
    fall: 'val',
    cycle: 'Cyclus',
    pad_cycle: '{pad}cyclus',
    off_body: 'off-body',
    pad_status_legend: 'Status van {pad}',
    analysing_diaper_legend: '{pad} analyseren',
    dry_wet_change_diaper: 'droge {pad}/natte {pad}/{pad} verschonen',
    pod_status: 'Status van pod',
    goal_status: 'Doelstatus',
    diaper_removed_legend: '{pad} verwijderd',
    time_to_change_legend: 'tijd-om-te-verschonen',
    out_of_range_legend: 'buiten-bereik',
    diaper_not_selected: '{pad} niet geselecteerd',
    duration: 'Duur',
    small_void: 'Kleine lozing',
    medium_void: 'Middelmatige lozing',
    large_void: 'Grote lozing',
    view_mode: 'Weergavemodus',
    voids_only: 'alleen lozingen',
    void_event_size: 'grootte lozingsgebeurtenis',
    pad_start: '{pad} start',
    pad_end: '{pad} einde',
    exceed_goal_time: 'Doeltijd overschrijden',
    reclip: 'opnieuw bevestigen',
    unstable_readings: 'Onstabiele metingen',
    not_selected: 'Niet geselecteerd',
    analysing: 'Analyseren',
    create_organisation: 'Organisatie aanmaken',
    all_times_are_in: 'Alle tijden zijn binnen',
    failed_to_get_goal_settings: 'Kan doelinstellingen niet ophalen',
    next_steps: 'Volgende stappen',
    video: 'Video',
    monitor_warning:
      'Monitoren is niet beschikbaar omdat er geen Smartz<sup>®</sup>-pod is toegewezen aan',
    find_further_information: 'Verdere informatie vinden',
    here: 'hier',
    savePatientPodErrMsg: `Het opgegeven pod-serienummer bestaat niet in deze organisatie.`,
    savePatientNodeErrMsg: `Het opgegeven mac-adres van de node bestaat niet in deze organisatie.`,
    already_registered_desc:
      'Meld u aan met uw gebruikersnaam en wachtwoord waarmee u zich aanvankelijk hebt geregistreerd.',
    create_account_desc:
      'Geef een gebruikersnaam en wachtwoord op om een gebruikersaccount aan te maken en om toegang te krijgen tot de site.',
    signing_in: 'Inloggen',
    signing_out: 'Uitloggen',
    welcome: 'Welkom',
    top: 'Boven',
    facility_or_building: 'Faciliteit / gebouw',
    keep_at_least_one_facility: 'Houd ten minste één faciliteit',
    keep_at_least_one_floor: 'Houd ten minste één verdieping aan',
    keep_at_least_one_room: 'Houd ten minste één kamer',
    rename: 'Hernoemen',
    domain_name: 'Domeinnaam',
    subscription_code: 'Abonnementscode',
    events: 'Gebeurtenissen',
    no_pods_text: 'Er zijn geen pods geregistreerd in deze organisatie.',
    no_nodes_text: 'Er zijn geen nodes geregistreerd in deze organisatie.',
    confirm_deletion: 'Verwijderen bevestigen.',
    confirm_archive: 'Archief bevestigen.',
    account_deletion: 'Verwijderen van account',
    delete_account_warning:
      'Verwijderen van gebruikersaccount en persoonsgegevens is permanent.',
    deletion: 'Verwijdering',
    restoring_patient: '{patient} herstellen',
    font_family: 'Lettertypefamilie',
    font_size: 'Lettergrootte',
    font_color: 'Lettertypekleur',
    main_title: 'Hoofdtitel',
    title: 'Titel',
    small_title: 'Korte titel',
    body_text: 'Hoofdtekst',
    body_text_small: 'Hoofdtekst (klein)',
    supplementary_text: 'Aanvullende tekst',
    primary_text: 'Primaire tekst',
    regular_text: 'Gewone tekst',
    secondary_text: 'Secundaire tekst',
    placeholder_text: 'Tijdelijke tekst',
    top_nav_background: 'Hoofdnavigatie achtergrond',
    edit_facility_and_floor_and_room:
      'Faciliteit, verdieping en kamer bewerken',
    please_select_buildings: 'Selecteer gebouwen',
    please_select_floors: 'Selecteer verdiepingen',
    please_select_rooms: 'Selecteer kamers',
    facility_setup: 'Instelling faciliteit',
    view_a_patient_by_selecting_from_drop_down_menu:
      'Een {patient} bekijken door te selecteren uit vervolgkeuzemenu.',
    monitoring: 'monitoring',
    silencing: 'Stilte maken',
    fall_detection: 'valdetectie',
    pod: 'Pod',
    diaper: '{pad}',
    time_in_diaper: 'Tijd in {pad}',
    setup_area_filter_desc:
      'Volg deze stappen om een nieuw gebiedsfilter in te stellen.',
    max_time_in_pad: 'Maximale tijd in {pad}',
    max_time_in_pos: 'Maximale tijd in positie',
    change_in: 'verandering in',
    not_monitoring: 'Niet monitoren',
    exceed_allowed_time: 'Overschrijding Toegestane tijd',
    exceed_predicted_time: 'De voorspelde tijd overschrijden',
    Pseudonymized: 'Gepseudonimiseerd',
    Anonymized: 'Geanonimiseerd',
    pseudonymized_permission_warning:
      'Gepseudonimiseerde toestemming van {patient} en bewerkingstoestemming van {patient} kunnen niet tegelijkertijd worden geselecteerd. Selecteer er een.',
    anonymized_permission_warning:
      'Geanonimiseerde toestemming van {patient} en bewerkingstoestemming van {patient} kunnen niet tegelijkertijd worden geselecteerd. Selecteer er een.',
    please_select_one_product: 'Selecteer een dagproduct of nachtproduct',
    none: 'Geen',
    invitation: 'Uitnodiging',
    has_invited: 'heeft uitgenodigd',
    to_join: 'om deel te nemen',
    invitation_desc:
      'Als u al een account heeft met dit e-mailadres, meld u dan aan om deel te nemen.',
    if_not_please: 'Zo niet, graag',
    accept: 'accepteren',
    decline: 'weigeren',
    acceptable_temperature_range: 'acceptabel temperatuurbereik',
    temperature_alert_off: 'De temperatuurwaarschuwing is uit',
    temperature_alert_on:
      'De temperatuurwaarschuwing is ingesteld om te activeren als de temperatuur is',
    below: 'onder',
    above: 'boven',
    partial_body_repositioning: 'Gedeeltelijke lichaamsherpositionering',
    minimum_angle_change: 'minimale hoekverandering',
    degrees: 'graden',
    goal_time_exceed: 'Doeltijd overschrijdt',
    allowed_time_exceed: 'Toegestane tijd overschrijdt',
    predicted_time_exceed: 'Voorspelde tijd overschrijdt',
    safe_time_exceed: 'Veilige tijd overschrijdt',
    brief_not_used: '{pad} niet gebruikt',
    monitor_unstable_readings: 'Bewaak onstabiele metingen',
    leakage: 'Lekkage',
    new_battery: 'Nieuwe batterij',
    exceed_safe_time_in_pad: 'Veilige tijd overschrijden in {pad}',
    predicted_change_time: 'Voorspelde verschoningstijd',
    total_time: 'totale tijd',
    exceed_safe_time: 'Veilige tijd overschrijden',
    consider_using_smartz_product: 'overweeg smartz-product te gebruiken',
    non_smartz_product_in_use: 'Niet-smartz-product in gebruik',
    product_not_selected: 'product niet geselecteerd',
    assign_smartz_product_to_patient: 'smartz-product toewijzen aan {patiënt}',
    wait_a_moment: 'wacht even...',
    find_patient: 'vind {patient}',
    life: 'Leven',
    flat_battery: 'lege batterij',
    compliance_notifications: 'Nalevingsmeldingen',
    receive_email_notifications:
      'Ontvang e-mailmeldingen met betrekking tot systeemgebruik en naleving',
    example: 'Voorbeeld',
    receive_email_desc1:
      'wanneer lege batterijen van de pod niet tijdig worden vervangen, wat kan leiden tot het onvermogen om {patients} te controleren',
    receive_email_desc2: 'wanneer zorgpersoneel de nalevingsdoelen niet haalt',
    i_want_to_receive_these_notifications: 'Ik wil deze meldingen ontvangen',
    subscribe_successfully: 'Succesvol aanmelden',
    unsubscribe_successfully: 'Succesvol uitschrijven',
    voltage: 'Voltage',
    generate: 'Genereren',
    generate_report: 'Rapport genereren',
    period: 'Periode',
    baseline: 'Basislijn',
    trial: 'Proef',
    generate_in_progress: 'Bezig met genereren',
    generate_desc: `Rapportgegevens worden geëxporteerd. U wordt per e-mail op de hoogte gesteld wanneer deze beschikbaar is. Controleer de voortgang in het geschiedenismenu.`,
    report_history: 'Rapportgeschiedenis',
    double_tap: 'Dubbeltikken',
    time_period_inconsistent_warning:
      'De tijdspanne van periode 1 en periode 2 moet consistent zijn',
    trial_reports: 'Proefverslagen',
    'Trial Reports': 'Proefverslagen',
    Generate: 'Genereren',
    resend_code: 'Code opnieuw verzenden',
    verification_required: 'Verificatie vereist',
    security_step_up: 'Beveiligingsstap omhoog',
    security_step_up_desc:
      'We verifiëren nu uw aanmeldingen als gevolg van het upgraden van uw beveiligingsniveau',
    we_have_sent_mfa_code_first_line: `We hebben een 6-cijferige beveiligingscode naar uw e-mailadres gestuurd`,
    we_have_sent_mfa_code_second_line: `Deze extra stap laat zien dat u het echt bent`,
    enter_secure_code: 'Beveiligingscode invoeren',
    trust_this_browser: 'Vertrouw deze browser',
    trust_browser_first_line:
      'Als u de browser op deze computer vertrouwt, wordt u de volgende keer dat u inlogt niet om tweestapsverificatie gevraagd',
    trust_browser_second_line: `U mag nooit' de browser vertrouwen 'wanneer u een openbare of gedeelde computer gebruikt en we raden u aan alleen browsers te vertrouwen die u regelmatig gebruikt`,
    not_now: 'Niet nu',
    browser_can_not_be_trust: `Browsers kunnen niet worden vertrouwd in de privémodus. Selecteer 'Niet nu' om door te gaan met inloggen`,
    Observation: 'Observatie',
    observation: 'Observatie',
    common_area: 'Gemeenschappelijke ruimte',
    qr_code: 'QR-code',
    please_enter_patient_alias_to_search:
      'Voer alias van {patient} in om te zoeken',
    smartz_observations: 'Smartz-observaties',
    scan_this_code_to_record_and_observation:
      'Scan deze code om <br /> op te nemen en te observeren',
    need_help: 'Hulp nodig',
    scan_this_code_to_learn_about_smartz:
      'Scan deze code om meer te weten te komen over Smartz',
    summary: 'SAMENVATTING',
    incontinent_event_frquency: 'Frequentie van incontinentiegebeurtenissen',
    bladder_daily: 'Blaas (dagelijks)',
    weekly: 'Wekelijks',
    bowel_daily: 'Darm (dagelijks)',
    diaper_utilisation: 'Gebruik van {pad}',
    day_pad: '{pad} dag',
    usage: 'Gebruik',
    units_during_day: 'eenheden tijdens dag',
    average_fill: 'Gemiddelde vulling',
    night_pad: `{pad}'s nachts`,
    unit_at_night: `eenheden's nachts`,
    averaxe_fill: 'gemiddelde vulling',
    Period: 'Periode',
    Observations: 'Observaties',
    No_Observations: 'Geen observaties',
    data_quality: 'Gegevenskwaliteit',
    pod_out_of_range: 'Pod buiten bereik',
    Assessment: 'Beoordeling',
    Day: 'Dag',
    inco_assessment: 'INCO-EVALUATIE',
    bladder_chart: 'BLAASGRAFIEK',
    week: 'week',
    count: 'Telling',
    inco_assessment_email_content:
      'De per e-mail verzonden Grafiek voor Incontinentie-evaluatie kan door u worden bekeken.',
    observation_chart: 'Observatiegrafiek',
    inco_observation_chart_content:
      'De per e-mail verzonden Observatiegrafiek kan door u worden bekeken.',
    product_name: 'Productnaam',
    total_void: 'Totale leging van blaas',
    utilisation: 'Gebruik',
    node_network_error_msg:
      'Het Dashboard kan op dit moment niet worden bijgewerkt vanwege een verbroken verbinding met het Smartz Node-netwerk in uw faciliteit. Neem contact op met uw IT-ondersteuningsteam',
    'Inco Assessment': 'INCO-evaluatie',
    'Observation Chart': 'Observatiegrafiek',
    reporting: 'Rapportage',
    reporting_page_desc:
      'De volgende informatie over uw organisatie wordt gebruikt in Rapportage',
    baseline_trial_periods: 'BASELINE/ PROEFPERIODEN',
    rounds_shifts: 'Rondes / Diensten',
    to_access_reports_go_to: 'Om toegang te krijgen tot rapporten ga naar',
    portal: 'portal',
    you_are_about_to_remove_this_item:
      'U staat op het punt dit item te verwijderen',
    add_round: 'Ronde / dienst toevoegen',
    edit_round: 'Ronde / dienst bewerken',
    poster_qr_code: 'Degene die QR-code heeft geplaatst',
    smartz_id_card: 'Smartz ID-kaart',
    card_qr_code: 'QR-code van kaart',
    id_card: 'ID-kaart',
    'Privacy Mode': 'Privacymodus',
    bed_number: 'Bednummer',
    please_input_bed_number: 'Voer het bednummer in',
    range: 'Bereik',
    please_enter_name: 'Voer een naam in',
    please_select_range: 'Selecteer bereik',
    core_breakup: 'Kernbreuk',
    body_repositioning: 'Lichaamsherpositionering',
    Dashboard: 'Dashboard',
    Organisations: 'Organisaties',
    RolesPermission: 'Rollentoestemming',
    Network: 'Netwerk',
    Void: 'Legen van blaas',
    BodyPosition: 'Lichaamshouding',
    Event: 'Gebeurtenis',
    FillProfile: 'Vullingprofiel',
    SkinCare: 'Huidsverzorging',
    Chars: 'Grafieken',
    Goals: 'Doelen',
    Node: 'Knooppunt',
    Pod: 'Pod',
    Reports: 'Rapporten',
    Invite: 'Uitnodigen',
    Private: 'Privé',
    'Inco-assessment': 'Inco-evaluatie',
    application_link_key: 'Applicatiekoppelingssleutel',
    application_link_key_desc: `Dit is een sleutel die aan uw organisatie is gekoppeld.`,
    remove_application_link_key_desc: `Verwijder deze sleutel als u niet wilt koppelen, of u kunt`,
    generate_a_new_one: 'genereer een nieuwe',
    generate_new_application_link_key_warning:
      'De nieuw gegenereerde sleutel overschrijft de vorige koppelingssleutel',
    delete_application_link_key_warning: `U staat op het punt deze applicatielink-sleutel te verwijderen`,
    copied_to_clipboard: 'Gekopieerd naar klembord',
    failed_to_copy: 'Kopiëren mislukt',
    template: 'Sjabloon',
    please_select_a_template: 'Selecteer een sjabloon',
    Charts: 'Grafieken',
    choose_permission_template_desc:
      'Kies een van de onderstaande sjabloonrollen om automatisch machtigingen in te vullen. U kunt vervolgens de machtigingen aanpassen op basis van uw specifieke vereisten ',
    Interoperability: 'Interoperabiliteit',
    comment: 'Opmerking',
    please_enter_comment: 'Voer een opmerking in',
    filter_by_organization_name: 'filteren op organisatienaam',
    physical_activity_chart: 'Grafiek van fysieke activiteiten',
    stationary: 'stationair',
    sit_stand: 'zitten/staan',
    walk: 'lopen',
    jog: 'joggen',
    run: 'rennen',
    physical_activity_chart_content:
      'De per e-mail verzonden grafiek met fysieke activiteiten kan door u worden bekeken.',
    PhysicalActivity: 'Lichamelijke activiteit',
    bed_number_is_not_available: 'Dit bednummer is niet beschikbaar',
    show_archived_patients: 'Gearchiveerde {patients} weergeven',
    archived: 'Gearchiveerd',
    create_facility: 'Faciliteit aanmaken',
    create_new_organisation: 'Een nieuwe organisatie aanmaken',
    add_role_title: 'Rol toevoegen',
    create_new_role: 'Een nieuwe rol aanmaken',
    create_new_manufacturer: 'Een nieuwe fabrikant aanmaken',
    create_a_secondary_user: 'Een secundaire gebruiker toevoegen',
    please_enter_password: 'Voer het wachtwoord in',
    please_enter_password_again: 'Voer het wachtwoord opnieuw in',
    password_rule:
      'Wachtwoord moet hoofdletters, kleine letters, cijfers en speciale tekens bevatten.',
    password_length_rule: 'Wachtwoord moet uit 8 tot 12 tekens bestaan.',
    reset_password_successfully: 'Wachtwoord met succes opnieuw instellen',
    invited_user_list: 'Uitgenodigde gebruikerslijst',
    basic_settings: 'Basisinstellingen',
    language: 'Taal',
    date_time_format: 'Datum Tijd Indeling',
    measure_unit: 'Meeteenheid',
    custom_system_terms: 'Aangepaste systeemvoorwaarden',
    custom: 'aangepast',
    singular: 'Enkelvoud',
    plural: 'Meervoud',
    term: 'Looptijd',
    pad_term_not_select_warning:
      'Selecteer een padlooptijd of voer een aangepaste looptijd in',
    patient_term_not_select_warning:
      'Selecteer patiëntenlooptijd of voer een aangepaste looptijd in',
    register_an_installation_id: 'Een installatie-ID registreren',
    register_an_installation_id_desc:
      'Registreert de organisatie bij het een netwerk met een lijst van knooppunten en pods',
    installation_id: 'Installatie-ID',
    please_enter_installation_id: 'Voer de installatie-ID in',
    register_an_installation_id_successful:
      'Registratie installatie-ID succesvol',
    your_organization_is_already_linked_site:
      'Uw organisatie is al gekoppeld aan de',
    you_can: 'U kan',
    add_a_different_installation_id: 'Een andere installatie-ID toevoegen',
    remove_this_installation_id: 'Deze installatie-ID verwijderen',
    your_organization_is_not_link_organisation:
      'Uw organisatie is nog niet gekoppeld aan het Smartz-knooppuntennetwerk, gelieve',
    add_installation_id_desc:
      'Als u een installatie-id toevoegt, wordt deze organisatie gekoppeld aan een Smartz-knooppuntennetwerk. Het zal deze organisatie in staat stellen om toegang te krijgen tot alle knooppunten en pods die beschikbaar zijn in dat netwerk.',
    link_another_installation_id_warning:
      'Houd er rekening mee dat dit de link naar het vorige Smartz Node-netwerk verbreekt en een nieuw netwerk aanmaakt. Sommige knooppunten en pods die deel uitmaakten van een oudere installatie-id zijn mogelijk niet beschikbaar.',
    remove_installation_id_warning:
      'Houd er rekening mee dat dit de link naar het vorige Smartz-knooppuntnetwerk verbreekt. Knooppunten en pods die deel uitmaakten van de huidige installatie-id zijn mogelijk niet beschikbaar.',
    remove_successful: 'Verwijderen gelukt',
    add_lora_network: 'Een LoRa-netwerk toevoegen',
    add_a_lora_network: 'Een LoRa-netwerk toevoegen',
    add_a_different_lora_network: 'Voeg een ander LoRa-netwerk toe',
    remove_this_lora_network: 'Dit LoRa-netwerk verwijderen',
    application_id: 'Toepassing-ID',
    please_enter_application_id: 'Voer alstublieft de toepassings-ID in',
    add_lora_network_successful: 'LoRa-netwerk toevoegen gelukt',
    your_organization_is_already_linked_lora_network:
      'Uw organisatie is al aan een LoRa-netwerk gekoppeld',
    your_organization_is_not_link_lora_network:
      'Uw organisatie is nog niet aan een LoRa-netwerk gekoppeld, alstublieft',
    add_lora_network_desc:
      'Het toevoegen van een LoRa-netwerk zal deze organisatie aan een LoRa-netwerk koppelen. Dit zal deze organisatie in staat stellen om toegang te krijgen tot alle LoRa-apparaten die beschikbaar zijn in dat netwerk.',
    link_another_lora_network_warning:
      'Houd er rekening mee dat dit de koppeling met het vorige LoRa-netwerk verbreekt en een nieuw netwerk maakt. Sommige apparaten die deel uitmaakten van een ouder LoRa-netwerk zijn mogelijk niet beschikbaar.',
    remove_lora_network_warning:
      'Houd er rekening mee dat dit de koppeling met het LoRa-netwerk verbreekt. Apparaten die deel uitmaakten van het huidige LoRa-netwerk zijn mogelijk niet beschikbaar.',
    'Dashboard Type': 'Dashboardtype',
    Carer: 'Verzorger',
    moodle_training: 'Moodle-training',
    care_plus_dashboard: 'Care Plus-dashboard',
    take_action: 'Actie ondernemen',
    task_completion_time: 'Taakvoltooiingstijd',
    too_early: 'Te vroeg',
    too_late: 'Te laat',
    ontime: 'Op tijd',
    great_work: 'Goed gedaan',
    pad_change_desc: `{patientAlias} is {time} geleden verschoond`,
    battery_change_desc: `De batterij van {patientAlias} is {time} geleden vervangen`,
    position_change_desc: `{patientAlias}'s houding is {time} geleden gewijzigd `,
    fall_event_desc: `De val van {patientAlias}is {time} geleden verholpen`,
    days_unit: 'dag(en)',
    hours_unit: 'uur/uren',
    minutes_unit: 'minuut/minuten',
    team_work: 'Teamwerk',
    your_care_team_is_doing_great: 'Je zorgteam doet het goed',
    a_few_things_to_improve_on:
      'Enkele dingen om te verbeteren om succes te behalen',
    improve_early_change_desc:
      'Verschoon {pad} alleen vanwege systeemwaarschuwingen, ontlasting, ingestelde doelen of lekkage. Vermijd routinematige verschoning.',
    improve_change_response_time_desc:
      'Controleer het dashboard regelmatig, handel onmiddellijk om {pads} te verschonen zodra de pictogrammen rood worden.',
    improve_goal_response_time_desc:
      'Zorg voor {patient} zodra het doelpictogram wordt weergegeven in het gedeelte Actie ondernemen.',
    improve_incorrect_clipping_desc:
      'Inspecteer pod en {pad} op defecten. Breng de pod op één lijn met de strepen voordat u deze vastzet en let op het knipperende groene lampje. Bekijk de trainer-app voor instructies.',
    improve_battery_change_desc:
      'Vervang de batterij onmiddellijk zodra deze op het dashboard of op de pod is aangegeven.',
    improve_leakage_desc:
      'Verschoon onmiddellijk {pad} bij rood pictogram. Beoordeel maatvoering van {pad} of aanbrengen van {pad}.',
    improve_frequent_lost_connection_desc:
      'Voorkom dat u de pod kwijtraakt of weggooit. Klem de pod vast aan het nieuwe {pad} en zorg ervoor dat {patient} zich binnen het dekkingsgebied bevindt.',
    low: 'Laag',
    medium: 'Gemiddeld',
    high: 'Hoog',
    improve_offline_nodes_desc: `Verscheidene knooppunten in uw netwerk zijn momenteel offline. Herstel deze knooppunten om ervoor te zorgen dat het systeem correct functioneert.`,
    team_support: 'Teamondersteuning',
    team_support_desc1: 'Waarschijnlijke achteruitgang in zorg!',
    team_support_desc2: 'Moet worden verbeterd',
    team_support_desc3: 'Kan beter',
    team_support_desc4: 'Nog niet helemaal daar',
    team_support_desc5: 'Oké, maar kan beter',
    team_support_desc6: 'Toont potentie',
    team_support_desc7: 'Heeft potentieel',
    team_support_desc8: 'Goed werk, streef naar perfectie!',
    team_support_desc9: 'Sterke inspanning',
    team_support_desc10: 'Indrukwekkend',
    team_support_desc11: 'Uitstekend, niet stoppen!',
    team_support_desc12: 'Fantastisch, ga zo door!',
    team_support_desc13: 'Geweldige inspanning! Niet stoppen',
    team_support_desc14: 'Uitzonderlijk, ga zo door!',
    team_support_desc15: 'Uitmuntend, ga zo door!',
    insufficient_data_warning:
      'Onvoldoende gegevens om feedback te geven. Wachten op {count} voltooide padcycli',
    demo_org_desc:
      'Deze organisatie zal worden gebruikt voor demonstratiedoeleinden',
    overall_evaluation: 'Algehele beoordeling',
    demonstration_mode: 'Demonstratiemodus',
    responsiveness: 'Reactievermogen',
    predicted_red: 'Voorspelde Rood',
    predicted_mode: 'Voorspelde Modus',
    predicted_time: 'Geschatte tijd',
    display_time_in_dashboard: 'Tijd weergeven in dashboard',
    nurse_call_dashboard: 'Verpleegoproep-dashboard',
    organisation_code: 'Organisatiecode',
    generate_new: 'Nieuw genereren',
    check_bin: 'Controleer de prullenbak',
    filter_module_selection_background_color:
      'Achtergrondkleur van filtermodule-selectie',
    filter_module_selection_text_color: 'Tekstkleur van filtermodule-selectie',
    filter_module_label_color: 'Labelkleur van filtermodule',
    quick_action_icon_color: 'Kleur van snelkoppelingspictogram',
    padding: 'Opvulling',
    bottom: 'Onderkant',
    other: 'Overig',
    peel_and_apply: 'Afnemen en aanbrengen',
    calibration_in_progress: 'Kalibratie bezig',
    apply_sensor: 'Sensor toepassen',
    apply_sensor_desc: 'Wachten tot de sensor wordt toegepast',
    record_pod_change: 'Pod-wijziging registreren',
    pod_change_history: 'Pod-wijzigingsgeschiedenis',
    change_date: 'Wijzigingsdatum',
    reason: 'Reden',
    loggged_in_date: 'Inlogdatum',
    check_connection_status: 'Verbinding controleren',
    check_connection_desc: 'Wachten op podverbinding...',
    checking_connection: 'Verbinding controleren',
    max_sensor: 'Max-sensor',
    loosely_connected_reclip_pod: 'Losse verbinding – Reclip Pod',
    loosely_connected: 'Losse verbinding',
    sensor: 'Sensor',
    embedded: 'Ingebed',
    p_n_a: 'PnA',
    change_reason: 'Wijzigingsreden',
    please_select_change_reason: 'Selecteer de reden van de wijziging',
    feedback: 'Feedback',
    pad_weight: '{pad}-gewicht',
    export_pad_cycle_description:
      'Klik op de onderstaande knop om de {pad}-cyclusgegevens te exporteren',
    pad_weight_data_saved: '{pad}-gewichtgegevens opgeslagen:',
    pad_capacity_reached: '{pad}-capaciteit bereikt',
    actual_weight: 'Werkelijk gewicht',
    not_provided: 'Niet opgegeven',
    pad_weight_first_question:
      'Was de {pad} vol genoeg om vervangen te worden?',
    pad_weight_second_question: 'Heeft u een werkelijk luiergewicht?',
    actual_weight_provided: 'Werkelijk gewicht opgegeven',
    leakages: 'Lekken',
    max_time_in_wet_pad: 'Maximale tijd in natte {pad}'
  },
  country: 'Dutch',
  language: 'Nederlands',
  abb_name: 'nl'
}
